import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "© Цифровая платформа транспортной логистики (GT2)", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Правообладатель ООО «Глобалтрак информационные технологии»", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Свидетельство о регистрации программы № 2022612914", -1)
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_modal_with_content = _resolveComponent("ui-modal-with-content")!

  return (_openBlock(), _createBlock(_component_ui_modal_with_content, {
    target: "modal",
    width: 530,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
  }, {
    header: _withCtx(() => [
      _createTextVNode(" О программе GT2 ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.container)
      }, [
        _createElementVNode("img", {
          alt: "gt2",
          src: $options.img,
          class: _normalizeClass(_ctx.$style.img)
        }, null, 10, _hoisted_1),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.text)
        }, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          ($options.version)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Версия ПО: " + _toDisplayString($options.version.environment) + " " + _toDisplayString($options.version.version), 1))
            : _createCommentVNode("", true)
        ], 2)
      ], 2)
    ]),
    _: 1
  }))
}